import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Importa useLocation

import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import {Modal, Button, Form, Row, Col, Dropdown } from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";
import { FloatCardComponent, ListadoUsuariosGiraComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import {getEstablecimientos, getRegiones, getComunas, getProgramas, getTramos, getReporteGiras, descargarArchivo} from "../../api/mantenedores.ts";
import {editarGira, getGira} from "../../api/giras.ts";
import Swal from 'sweetalert2';

export default function GiraViewPage() {

    const { t } = useContext(TranslatorContext)
    const location = useLocation();

    const [giraData, setGiraData] = useState([]);
    const [giraDataView, setGiraDataView] = useState([]);
    const [reporteData, setReporteData] = useState([]);


     const [selectEstablecimiento, setSelectEstablecimiento] = useState([]);
        const [selectRegion, setSelectRegion] = useState([]);
        const [selectComuna, setSelectComuna] = useState([]);
        const [selectPrograma, setSelectPrograma] = useState([]);
        const [selectTramo, setSelectTramo] = useState([]);
        const [comunas, setComunas] = useState([]);
        const [showCreateGiraModal, setShowCreateGiraModal] = useState(false);

        const handleShowCreateGiraModal = () => setShowCreateGiraModal(true);
        const handleCloseCreateGiraModal = () => setShowCreateGiraModal(false);

    
     useEffect(() => {
                const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
                const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
               
                
                const fetchTabla = async () => {
                  
                    const res = await getGira(giraId);
                    
                    setGiraData(res.gira);
                     setGiraDataView(res.gira);
                    setReporteData(res.reporte);

                }
                
                 const fectchProgramas = async () => {
                                const res = await getProgramas();
                                console.log(res);
                                setSelectPrograma(res.data);
                            }
                
                            const fectchTramos = async () => {
                                const res = await getTramos();
                                console.log(res);
                                setSelectTramo(res.data);
                            }
                
                            const fectchEstablecimientos = async () => {
                                const res = await getEstablecimientos();
                                console.log(res);
                                setSelectEstablecimiento(res.data);
                            }
                
                            const fecthregiones = async () => {
                                const res = await getRegiones();
                                console.log(res);
                                setSelectRegion(res.data);
                            }   
                    
                            const fecthComunas = async () => {
                                const res = await getComunas();
                                console.log(res);
                                setSelectComuna(res.data);
                            }
                 fectchProgramas();
                fectchTramos();
                fectchEstablecimientos();
                fecthregiones();
                fecthComunas();
                
                fetchTabla();   
               
            }, []);

            useEffect(() => {
                if (showCreateGiraModal && giraData.idregion) {
                     const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(giraData.idregion));
                   
                    setComunas(fetchedComunas);
                }
            }, [showCreateGiraModal, giraData.idregion]);

            const handleInputChange = (event) => {
                const { name, value } = event.target;
                setGiraData({
                    ...giraData,
                    [name]: value
                });
                console.log(giraData);
            };

            const handleRegionChange = (event) => {
            const { value } = event.target;
            setGiraData({
                ...giraData,
                region: value,
                comuna: '' // Reset comuna when region changes
            });
            // Fetch comunas based on selected region
            fetchComunas(value);
        };

        
    const fetchComunas = (regionId) => {
        // Replace with your actual API call
        const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);
    };

    const toInputDate = (fecha) => {
          if (!fecha) return "";
            // Si ya está en formato yyyy-mm-dd, retorna igual
            if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha;
            // Si está en formato dd/mm/yyyy, lo transforma
            const [d, m, y] = fecha.split("/");
            return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }    

    const handleEditarGira = () => {
            // Aquí puedes manejar la lógica para crear la gira de estudios
        
            editarGira(giraData)
            .then(async res => {
              Swal.close();
           //  fetchTabla();
              if (res.error === false) {
                 const res = await getGira(giraData.gir_id);
                    
                    setGiraData(res.gira);
                     setGiraDataView(res.gira);
                    setReporteData(res.reporte);
                    
                Swal.fire({
                  icon: 'success',
                  text: 'Gira editada correctamente.'
                })
                
              }
              else {
                let errorMsg = res.msg;
                if (res.errores) {
                  errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
                  res.errores.forEach(error => {
                    errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
                  });
                  errorMsg += '</tbody></table>';
                }
    
                Swal.fire({
                  icon: 'error',
                
                  html: errorMsg
                })
              }
    
            });
          
            handleCloseCreateGiraModal();
        };

    const floats = [
        { "title": "Total Gira", "digit": ((giraDataView.gir_pagodolares === true || giraDataView.gir_pagodolares === 1 || giraDataView.gir_pagodolares?.data?.[0]) ? "US$" : "$") + reporteData.total_gira?.toLocaleString('es-CL'), "icon": "shopping_cart", "variant": "sm pink" }, 
        { "title": "Pagado", "digit": ((giraDataView.gir_pagodolares === true || giraDataView.gir_pagodolares === 1 || giraDataView.gir_pagodolares?.data?.[0]) ? "US$" : "$") + parseInt(reporteData.total_pagado || 0)?.toLocaleString('es-CL'), "icon": "hotel_class", "variant": "sm  blue" },
        { "title": "Deuda", "digit": ((giraDataView.gir_pagodolares === true || giraDataView.gir_pagodolares === 1 || giraDataView.gir_pagodolares?.data?.[0]) ? "US$" : "$") + reporteData.deuda?.toLocaleString('es-CL'), "icon": "shopping_bag", "variant": "sm orange" }
    ]
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Gira de Estudio</h3>
                            <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col xl={5}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Detalle Gira</h4>
                            <Dropdown bsPrefix="mc-dropdown">
                                <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                                    <i className='material-icons'>more_horiz</i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" className="mc-dropdown-paper">
                                    <button type='button' className='mc-dropdown-menu'  onClick={handleShowCreateGiraModal}><i className='material-icons'>edit</i><span>Editar Gira</span></button>
                                    
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="mc-user-group">
                            <div className="mc-user-profile">
                                <div className="mc-round-avatar md">
                                    <img src="images/LogoEmail.png" alt="avatar" />
                                </div>
                                <div className="mc-duel-text md">
                                    <h3 className="mc-duel-text-title">{giraDataView.est_nombre} - CURSO: {giraDataView.gir_curso} </h3>
                                    <p className="mc-duel-text-descrip"></p>
                                </div>
                            </div>
                            <div className="mb-4">
                                <h6 className="mc-divide-title mb-4">Información</h6>
                                <ul className="mc-user-metalist">
                                <li><i className="material-icons">map</i><span>Programa: {giraDataView.programa}</span></li>
                                <li><i className="material-icons">map</i><span>Tramo: {giraDataView.tramo}</span></li>
                                <li><i className="material-icons">attach_money</i><span>Moneda: {(giraDataView.gir_pagodolares === true || giraDataView.gir_pagodolares === 1 || giraDataView.gir_pagodolares?.data?.[0]) ? "Dólares (USD)" : "Pesos Chilenos (CLP)"}</span></li>
                                <li><i className="material-icons">map</i><span>Multa:  {giraDataView.gir_multa?.data[0] ? "Aplica Multa" : "No Aplica Multa"}</span></li>
                                 <li><i className="material-icons">map</i><span>Tipo Multa: {giraDataView.gir_mulmensual?.data[0] ? "Aplica Multa Mensual" : "Aplica Multa Semanal"}</span></li>
                                 <li><i className="material-icons">map</i><span>Porcentaje Multa:  {giraDataView.gir_porcmulta}%</span></li>
                                <li><i className="material-icons">map</i><span>Liberados: {giraDataView.gir_liberados}</span></li>
                                <li><i className="material-icons">map</i><span>Numero de Cuota: {giraDataView.gir_numcuotas}</span></li>
                                    <li><i className="material-icons">map</i><span>Comuna: {giraDataView.com_nombre}</span></li>
                                    <li><i className="material-icons">map</i><span>Región: {giraDataView.reg_nombre}</span></li>
                                    <li><i className="material-icons">map</i><span>Fecha Viaje: {giraDataView.gir_fviaje}</span></li>
                                    <li><i className="material-icons">map</i><span>Nombre Contacto: {giraDataView.gir_contacto}</span></li>
                                    <li><i className="material-icons">map</i><span>Celular Contacto: {giraDataView.gir_celcontacto}</span></li>
                                    <li><i className="material-icons">map</i><span>Email Contacto: {giraDataView.gir_emailcontacto}</span></li>
                                   
                                </ul>
                            </div>
                            
                           
                        </div>
                    </div>
                </Col>
                <Col xl={7}>
                    <Row>
                        {floats.map((float, index) => (
                            <Col md={4} lg={4} key={ index }>
                                <FloatCardComponent 
                                    variant={ float.variant }
                                    digit={ float.digit }
                                    title={ float.title }
                                    icon={ float.icon }
                                />
                            </Col>
                        ))}
                        <Col xl={12}> 
                            <ListadoUsuariosGiraComponent gira={giraDataView} /> 
                        </Col>
                    </Row>
                </Col>
            </Row>


            <Modal show={showCreateGiraModal} onHide={handleCloseCreateGiraModal}>
                        <div className="mc-alert-modal">
                            <Modal.Header closeButton>
                                <Modal.Title>Editar Gira de Estudios</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                              
                                      
                                    <Form.Group controlId="formTramo">
                                        <Form.Label>Tramo</Form.Label>
                                        <Form.Select name="idtramo"  value={giraData.idtramo || ""} onChange={handleInputChange} >
                                            <option>Seleccionar Tramo</option>
                                            {selectTramo?.map((tramo) => (
                                                <option key={tramo.id} value={tramo.id}>{tramo.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                   
                                   
                                    <Form.Group controlId="formCurso">
                                        <Form.Label>Curso</Form.Label>
                                        <Form.Control type="text" name="gir_curso" value={giraData.gir_curso} onChange={handleInputChange} />
                                    </Form.Group>
                                   
                                   
                                    <Form.Group controlId="formLiberados">
                                        <Form.Label>Liberados</Form.Label>
                                        <Form.Control type="text" name="gir_liberados" value={giraData.gir_liberados} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaViaje">
                                        <Form.Label>Fecha del Viaje</Form.Label>
                                        <Form.Control type="date" name="gir_fviajeact"     value={giraData.gir_fviajeact} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Nombre del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_contacto" value={giraData.gir_contacto} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Celular del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_celcontacto" value={giraData.gir_celcontacto} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Email del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_emailcontacto" value={giraData.gir_emailcontacto} onChange={handleInputChange} />
                                    </Form.Group>
                                    
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseCreateGiraModal}>
                                    Cerrar
                                </Button>
                                <Button variant="primary" onClick={handleEditarGira}>
                                    Editar Gira
                                </Button>
                            </Modal.Footer>
                            </div>
                        </Modal>
        </PageLayout>
    )
}